// extracted by mini-css-extract-plugin
export default {"header":"Header_header__cZGBQ","h1":"Header_h1__srYxt","h2":"Header_h2__zYkLk","h3":"Header_h3__suITY","h4":"Header_h4__EIs+q","h5":"Header_h5__gv5Qk","h6":"Header_h6__Hnand"};